module.exports = __webpack_public_path__ + "static/media/pic4.28a8a03f.jpg";